<template>
  <div class="normal-danger" style="margin-bottom: 8px">
    <div class="normal-danger-icon">
      <i class="el-icon-warning"></i>
    </div>
    <div class="normal-danger-text">
      您未授权第三方应用，功能无法正常使用，请先
      <router-link
        class="text-link"
        :to="`/plat/${shopId}/shop/promotion/channel`"
        >安装第三方应用>></router-link
      >
    </div>
  </div>
</template>

<script>
import { getShopCorps } from "@/api/wechat";
import common from "@/mixin/common";
export default {
  name: "authCheck",
  data() {
    return {
      authInfo: {
        third: null,
        instead: null,
      },
    };
  },
  mixins: [common],
  methods: {
    async loadData() {
      let res = await getShopCorps();
      if (res.code !== 200) {
        this.$message.error(res.msg);
        return;
      }
      let thirds = res.data.filter((item) => {
        return item.authType == "THIRD_APP";
      });
      if (thirds.length > 0) {
        this.authInfo.third = thirds[0];
      }
      let insteads = res.data.filter((item) => {
        return item.authType == "INSTEAD_APP";
      });
      if (insteads.length > 0) {
        this.authInfo.instead = insteads[0];
      } else {
        this.showTips = true;
      }
      console.log("this.authInfo", this.authInfo);
    },
  },
};
</script>

<style lang="scss" scoped></style>
